import { render, staticRenderFns } from "./BaseTextSection.vue?vue&type=template&id=0afe7731&scoped=true&"
import script from "./BaseTextSection.vue?vue&type=script&lang=js&"
export * from "./BaseTextSection.vue?vue&type=script&lang=js&"
import style0 from "./BaseTextSection.vue?vue&type=style&index=0&id=0afe7731&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afe7731",
  null
  
)

export default component.exports